import { APISettings } from "../../config/ApiSettings";
import { BaseAPI } from "./baseApi";
const baseUrl = new APISettings().getApiURL();

class WorkflowStatusApi<WorkflowStatus> extends BaseAPI {
    public getAll: () => Promise<WorkflowStatus[]> = async() => {
        return (await BaseAPI.axios.get(`${baseUrl}/WorkflowStatus`)).data.output;
    }

    public getById: (id: number) => Promise<WorkflowStatus> = async(id: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/WorkflowStatus/${id}`)).data.output;
    }

    public getByActionId: (id: number) => Promise<WorkflowStatus[]> = async(id: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/WorkflowStatus/GetByActionId/${id}`)).data.output;
    }
}

export const workflowStatusApi = new WorkflowStatusApi();